import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './WorkflowTask.scss'
import { Close } from '@mui/icons-material';
import HelpLink from '../../../../components/library/common/HelpLink';
import Button from '../../../../components/library/buttons/Button';
import DefaultModal from '../../../../components/library/modal/DefaultModal';
import HrbTranslate from '../../../../components/language/HrbTranslate';
import WorkflowStatusIcon from '../../../../components/library/workflow-tasks/WorkflowStatusIcon';
import { TicketState } from '../../services/TicketState';
import RadioButton from '../../../../components/library/buttons/RadioButton';
import ticketStateService from '../../services/ticketState/TicketStateService';
import { useSelector } from 'react-redux';
import Skeleton from '../../../../components/library/loaders/Skeleton';
import Lang from '../../../../components/language/services/Lang';
import { Language } from '../../../../components/language/services/constants';
import TaskErrorText from '../../../../components/library/workflow-tasks/TaskErrorText';
import { TicketType } from '../../services/TicketType';


const CloseTicketModal = (props) => {
    const [inProgress, setInProgress] = useState(false);
    const [ticketStatus, setTicketStatus] = useState(TicketState.CLOSED_COMPLETED_IN_OFFICE)
    const [reason, setReason] = useState(null)
    const [reasons, setReasons] = useState(null)

    const lang = useSelector(x => (x.layout.lang || "en").toUpperCase())
    
    const ticketType = props.ticketType;
    const startCloseTicket = (ev) => {
        setInProgress(true)
        props.onCloseTicket(ticketStatus, reason);
    }

    const handleCancel = (ev) => {
        setInProgress(false);
        props.onCancel(ev);
    }

    const onSelectRadio = (value) => {
        setTicketStatus(value)
    }

    const onSelectReason = (ev) => {
        setReason(ev.target.value)
    }

    useEffect(() => {
        if (props.updateFailed) {
            setInProgress(false)
        }
    }, [props.updateFailed])

    useEffect(() => {
        async function getReasons() {
            var data = await ticketStateService.getReasons(ticketType)
            if (data) {
                setReasons(data)
            }
        }

        setInProgress(false)
        if (props.isOpen && !reasons) {
            getReasons();
        }
    }, [props.isOpen])

    return (
        <DefaultModal isOpen={props.isOpen}>
            <div className='workflow-modal'>
                <div className='header'>
                    <div className='header-title'>
                        <WorkflowStatusIcon status={props.status} />
                        <h4><HrbTranslate text='Tickets.CloseTicket.Title' /></h4>
                    </div>
                    <Close className='close-btn' onClick={handleCancel}/>
                </div>
                <div className='content'>
                    <div>
                        <div>
                            <p className='p1'><HrbTranslate text='Tickets.CloseTicket.Content1' /></p>  
                            <p className='mt-2'><HelpLink helpKey='0ProSupport/VDOPro/ClosingTicket.htm' /></p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <p className='p2'><HrbTranslate text='Tickets.CloseTicket.RadioLabel' /></p>
                            <div className='close_ticket_radio_holder'>
                                <RadioButton textKey='Tickets.CloseTicket.ClosedOfficeLabel' elementId={TicketState.CLOSED_COMPLETED_IN_OFFICE}
                                    checked={ticketStatus === TicketState.CLOSED_COMPLETED_IN_OFFICE} onChecked={onSelectRadio} />
                                <RadioButton textKey='Tickets.CloseTicket.CloseIncompleteLabel' elementId={TicketState.CLOSED_INCOMPLETE}
                                    checked={ticketStatus === TicketState.CLOSED_INCOMPLETE} onChecked={onSelectRadio} />
                            </div>
                        </div>
                    </div>
                    <div className='stretch'>
                        <p className='p2'><HrbTranslate text='Tickets.CloseTicket.SelectLabel' /></p>
                        {!reasons &&
                            <Skeleton />
                        }
                        {reasons &&
                            <div className='select' id='close_tix'>
                                <select id='reason-select-id' onChange={onSelectReason} defaultValue="">
                                <option value='' disabled>{Lang.getCurrentValue("Tickets.CloseTicket.SelectReason")}</option>
                                {reasons
                                    .filter(x => ticketType == TicketType.VIR.toUpperCase() ? x.ticketStateIdentifier === ticketStatus || x.identifier == "CL_FAILED_ID": x.ticketStateIdentifier === ticketStatus || x.ticketStateIdentifier === TicketState.CLOSED_COMPLETED_IN_OFFICE)
                                    .map((r, i) =>
                                    <option key={`reason-opt-${i}`} value={r.identifier}>{lang === Language.FRENCH ? r.name.fr : r.name.en}</option>
                                )}
                                </select>
                            </div>
                        }
                    </div>
                    {props.updateFailed &&
                        <div>
                            <TaskErrorText errorKey="Tickets.CloseTicket.ErrorFailed" />
                        </div>
                    }
                    <div>
                        <div className='button-holder'>
                            <Button
                                elementId='ticket-cancel-btn'
                                labelKey='Tickets.CloseTicket.CloseBtn'
                                buttonStyles='primary'
                                onClick={startCloseTicket}
                                loading={inProgress}
                                disabled={!ticketStatus || !reason}
                            />
                            <Button
                                elementId='ticket-cancel-btn'
                                labelKey='App.Cancel'
                                buttonStyles='tertiary'
                                onClick={handleCancel} />
                        </div>
                    </div>
                </div>
            </div>
        </DefaultModal>
    );
}

CloseTicketModal.whyDidYouRender = false;

CloseTicketModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    onCancel: PropTypes.func,
    onCloseTicket: PropTypes.func.isRequired,
    updateFailed: PropTypes.bool
}

export default CloseTicketModal